import { render, staticRenderFns } from "./MessageHistoryTable.vue?vue&type=template&id=dfc6c0b2&scoped=true&lang=pug"
import script from "./MessageHistoryTable.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryTable.vue?vue&type=style&index=0&id=dfc6c0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc6c0b2",
  null
  
)

export default component.exports